import millify from "millify";
import { ThreeDWrapper } from "../core/3d-wrapper.core";

export default function MetricCard({
  title,
  value,
  prefix,
  className,
  precision,
}: {
  title: string;
  value?: number;
  prefix?: string;
  className?: string;
  precision?: boolean;
}) {
  return (
    <ThreeDWrapper
      className={`flex flex-col justify-between items-start gap-5 md:gap-6 p-4 rounded-2xl w-full ${className}`}
      hover={false}
    >
      <div className="flex flex-col items-start w-full">
        <p className="font-figtree font-semibold text-xs md:text-base">
          {title}
        </p>
      </div>
      <p className="font-cabinetgrotesk font-medium text-2xl md:text-[38px] leading-5 md:leading-10 tracking-tight">
        {prefix} {
          precision ? value?.toFixed(3) : millify(value ?? 0)
        }
      </p>
    </ThreeDWrapper>
  );
}
